import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

// Generate a unique visitor hash based on browser fingerprint
const generateVisitorHash = (): string => {
  const data = [
    navigator.userAgent,
    navigator.language,
    screen.width,
    screen.height,
    screen.colorDepth,
    new Date().getTimezoneOffset(),
    navigator.hardwareConcurrency || 0,
  ].join('|');
  
  // Simple hash function
  let hash = 0;
  for (let i = 0; i < data.length; i++) {
    const char = data.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(36);
};

// Guards against duplicate tracking calls (React strict-mode double effects,
// remounts) which produced 409 conflict errors in the browser console.
const trackedKeys = new Set<string>();

const usePageTracking = () => {
  useEffect(() => {
    const trackPageView = async () => {
      const path = window.location.pathname;
      const today = new Date().toISOString().split('T')[0];
      const visitorHash = generateVisitorHash();
      const key = `${visitorHash}|${path}|${today}`;
      if (trackedKeys.has(key)) return;
      trackedKeys.add(key);

      try {
        // Single atomic server-side upsert avoids 409/401 conflict errors
        // that previously surfaced in the browser console.
        await supabase.rpc("track_page_view", {
          p_page_path: path,
          p_visitor_hash: visitorHash,
        });
      } catch (error) {


        // Silently fail - analytics should not break the app
      }
    };

    trackPageView();
  }, []);
};

export default usePageTracking;
